import GeoCoverage from './GeoCoverage';

export default GeoCoverage;
